const initState = {
    // DASHBOARD SIDEBAR
    dashboardSidebarToggle: false,
    dashboardSidebarSize: "0px", //50
    // For testing purpose isTestApp will be true.
    // In production isTestApp will be false.
    isTestApp: false,

    modalStyles: {
        content: {
            top: '55%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
        },
    },

    modalWidth: '30%',
    modalWidthMedium: '60%',
    modalWidthHuge: '80%',

    modalHeight: '30%',
    modalHeightMedium: '60%',
    modalHeightHuge: '80%',

    formLabelStyle: {
        fontSize: "16px",
        fontWeight: "bold",
    },

    modalTitleStyle: {
        fontSize: "18px",
        fontWeight: "bold",
    },

    modalInfoTextStyle: {
        fontSize: "14px",
        textAlign: 'start',
    },

    modalImpInfoTextStyle: {
        fontSize: "14px",
        color: "#a20000"
    }
}

const appControlReducer = (state = initState, action) => {
    // console.log(action);

    if (action.type === 'DASHBOARD_TOGGLE') {
        console.log(action.toggle)
        return {
            ...state,
            dashboardSidebarToggle: action.toggle,
            dashboardSidebarSize: action.toggle ? "200px" : "50px",
        }
    }
    return state;
}

export default appControlReducer;